import type React from 'react';
import styled from 'styled-components';

const Em = styled.em`
  font-weight: ${({ theme }) => theme.fontWeight.BOLD};
  color: ${({ theme }) => theme.palette.fgLoud};
`;

/**
 * Parses text with markdown-style emphasis patterns and returns styled React nodes.
 * Supports: **text** for bold emphasis.
 */
export const parseQuoteWithEmphasis = (quote: string): React.ReactNode[] => {
  const emphasisPattern = /\*\*[^*]+\*\*/g;

  const parts = quote.split(emphasisPattern).filter(Boolean);

  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <Em key={index}>{part.slice(2, -2)}</Em>;
    }
    return part;
  });
};
